export class AlfatronAmp {
    constructor(socket, log) {
        this.socket = socket;
        this.bass = 4;
        this.mute = false;
        this.treble = 4;
        this.volume = 30;
        this.input = 1;
        this.asyncHandlers = [
            {
                name: 'audioInputSelection',
                regExp: /([123])A1\./i,
                callback: (match) => {
                    this.input = parseInt(match[1], 10);
                    this.socket.send(`A: ${this.input} -> 1}`);
                },
            },
            {
                name: 'getStatus',
                regExp: /600%/i,
                callback: (match) => {
                    this.socket.send(`A: ${this.input} -> 1`);
                    this.socket.send(`Volume of LINE : ${this.volume}`);
                    this.socket.send(` Bass of LINE : ${this.bass}`); // space at beginning is correct
                    this.socket.send(`Treble of LINE : ${this.treble}`);
                    this.socket.send(`${this.mute ? 'Mute' : 'Unmute'}`);
                },
            },
            {
                name: 'setBass',
                regExp: /8(\d+)%/i,
                callback: (match) => {
                    this.bass = parseInt(match[1], 10);
                    this.socket.send(` Bass of LINE : ${this.bass}`);
                },
            },
            {
                name: 'setTreble',
                regExp: /9(\d+)%/i,
                callback: (match) => {
                    this.treble = parseInt(match[1], 10);
                    this.socket.send(`Treble of LINE : ${this.treble}`);
                },
            },
            {
                name: 'setVolume',
                regExp: /7(\d+)%/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`Volume of LINE : ${this.volume}`);
                },
            },
            {
                name: 'setVolumeMute',
                regExp: /0A(0|1)\./i,
                callback: (match) => {
                    this.mute = match[1] === '0';
                    this.socket.send(`${this.mute ? 'Mute' : 'Unmute'}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    // no response sent on invalid command
                },
            },
        ];
    }
}
AlfatronAmp.emulatorType = 'socketEmulator';
AlfatronAmp.key = '-NhbAIkd9iJI27JJfp7v';
